import { useAxios } from '@healthblocks-io/core'
import useSWR from 'swr'

import type { AllergySearchResult } from '@/modules/app/types/HealthParameter.types'

export function useAllergyCodeById(id: string | null) {
  const hbAxios = useAxios()

  return useSWR(id ? `/views/patient/allergy-code/${id}` : null, async (url) => {
    const response = await hbAxios.get<AllergySearchResult>(url)
    return response.data
  })
}
